export const columns = [
  {
    accessorKey: "taxType",
    header: "Tax Type",
    type: "string",
    flex: 1,
  },
  {
    accessorKey: "taxRate",
    header: "Tax Rate (%)",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.taxRate || " "} %`,
  },
  {
    accessorKey: "isActive",
    header: "Active",
    type: "boolean",
    flex: 1,
  },
  {
    accessorKey: "actions",
    header: "Actions",
    type: "string",
    flex: 1,
    accessorFn: (row: any) => ` ${row.actions || " "}`,
  },
];
